import { render, staticRenderFns } from "./MenuPriceAddEdit.vue?vue&type=template&id=6c0878aa"
import script from "./MenuPriceAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuPriceAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports